import { render, staticRenderFns } from "./PendingAnnouncement.vue?vue&type=template&id=3a059e88&scoped=true&"
import script from "./PendingAnnouncement.vue?vue&type=script&lang=js&"
export * from "./PendingAnnouncement.vue?vue&type=script&lang=js&"
import style0 from "./PendingAnnouncement.vue?vue&type=style&index=0&id=3a059e88&prod&lang=scss&scoped=true&"
import style1 from "./PendingAnnouncement.vue?vue&type=style&index=1&id=3a059e88&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a059e88",
  null
  
)

export default component.exports